import PageViewService from './page-view';

export default PageViewService;
